import { render } from "./foodBatchIndex.vue?vue&type=template&id=84e2b260"
import script from "./foodBatchIndex.vue?vue&type=script&lang=js"
export * from "./foodBatchIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__